import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Animazione mostrata mentre il sistema legge il file: un calice che si riempie, i vini che "scorrono"
// e messaggi che cambiano, cosi' chi aspetta capisce che sta lavorando (la lettura di un PDF puo' durare un minuto).
const STEPS_PDF = ["reading.pdf1", "reading.pdf2", "reading.pdf3", "reading.pdf4"];
const STEPS_FILE = ["reading.file1", "reading.file2", "reading.file3"];

const ReadingAnimation = ({ pdf }) => {
  const { t } = useTranslation("common");
  const steps = pdf ? STEPS_PDF : STEPS_FILE;
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => clearInterval(id);
  }, []);

  const step = Math.min(Math.floor(seconds / (pdf ? 12 : 3)), steps.length - 1);

  return (
    <div className="reading-anim" role="status" aria-live="polite">
      <svg className="reading-glass" viewBox="0 0 64 96" width="56" height="84" aria-hidden="true">
        <defs>
          <clipPath id="glassBowl"><path d="M12 6h40c0 26-4 44-20 46C16 50 12 32 12 6z" /></clipPath>
        </defs>
        <g clipPath="url(#glassBowl)">
          <rect className="reading-wine" x="6" y="6" width="52" height="50" />
        </g>
        <path d="M12 6h40c0 26-4 44-20 46C16 50 12 32 12 6z" fill="none" stroke="#8a6d1c" strokeWidth="2.5" strokeLinejoin="round" />
        <path d="M32 52v28M20 84h24" stroke="#8a6d1c" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
      <div className="reading-text">
        <div className="reading-title">{t(steps[step])}</div>
        <div className="reading-bar"><span /></div>
        <div className="small text-muted mt-1">
          {pdf ? t("reading.longWait") : t("reading.moment")} ({seconds}s)
        </div>
      </div>
    </div>
  );
};

export default ReadingAnimation;
